import styled from "styled-components";

export const PreviewDiv = styled.div`
    display: flex;
    flex:1;
    font-family: Roboto, Arial, Helvetica, sans-serif;
`;

export const PreviewPanelDiv = styled.div`
    padding: 10px;
`;

export const SummaryPanelDiv = styled.div`
    flex: 0 0 30%;
    display: flex;
`;

export const CenteredAreaLoaderDiv = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
`;
